import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const TooltipTriggerIcon = ({ name , isHidden  })=>/*#__PURE__*/ React.createElement(Icon, {
        width: 18,
        height: 18,
        className: classnames('tooltip__icon', {
            'tooltip__icon--hidden': isHidden
        }),
        name: name
    })
;

export { TooltipTriggerIcon };
//# sourceMappingURL=TooltipTriggerIcon.js.map
